import styles from "./News.module.css";
import { FaCalendarAlt } from "react-icons/fa";
import { useContent } from "../../hooks/useContent";

const FALLBACK_ITEMS = [
  {
    id: 1,
    title: "Conference 2025 Announced",
    date: "Nov 15, 2025",
    description:
      "The annual conference will take place in Tashkent, covering advanced research topics.",
  },
  {
    id: 2,
    title: "New Journal Issue Released",
    date: "Nov 10, 2025",
    description:
      "The latest issue of our journal includes articles on renewable energy and AI technologies.",
  },
  {
    id: 3,
    title: "Call for Papers Open",
    date: "Nov 5, 2025",
    description:
      "Submit your papers for the upcoming conference. Deadline: Dec 15, 2025.",
  },
];

export default function News() {
  const { content, loading } = useContent();
  const news = content.news || {};
  const header = news.header || {};
  const items =
    Array.isArray(news.items) && news.items.length > 0 ? news.items : FALLBACK_ITEMS;

  const title = header.title || "News & Updates";
  const subtitle =
    header.subtitle ||
    "Stay up-to-date with the latest news and announcements.";

  if (loading && !content.news) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <p className={styles.subtitle}>Загрузка…</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>

        <div className={styles.newsGrid}>
          {items.map((news) => (
            <div key={news.id} className={styles.newsCard}>
              <div className={styles.newsHeader}>
                <h2 className={styles.newsTitle}>{news.title}</h2>
                <span className={styles.newsDate}>
                  <FaCalendarAlt className={styles.icon} /> {news.date}
                </span>
              </div>
              <p className={styles.newsDescription}>{news.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
